import {ClsAccessToken} from './cls-access-token';

export class ClsDataEnvioCorreo {
  accessToken?: ClsAccessToken;
  from?: string;
  to?: string;
  cc?: string;
  bcc?: string;
  subject?: string;
  distribuidor?: string;
  codigoPedido?: string;
  fechaCaptura?: string;
  razonSocial?: string;
  concepto?: string;
  importeCliente?: number;
  ultimoAutorizo?: string;
  observaciones?: string;
  observacionesGral?: string;
  idEstatus?: number;
  archivosAdjuntos?: any;
}

export class ClsDatosAEnviar {
  From?: string;
  To?: string;
  Subject?: string;
  Contenido?: string;
}

export class ClsEnviarCorreo {
  accessToken?: ClsAccessToken;
  Raw?: string;
  parametrosEnvia?: ClsParametrosEnviaCorreo;
}

export class ClsParametrosEnviaCorreo {
  para: string[];
  cc?: string[];
  bcc?: string[];
  mensaje: string;
  subject: string;
  adjuntos: ClsAdjuntos[];
}

export class ClsAdjuntos {
  nombreArchivo: string;
  tipoArchivo: string;
  contenidoBytes: string;
}

export class ClsArchivoBase64 {
  name?: string;
  base64?: string | ArrayBuffer;
  type?: string;
  size?: number;
  lastModified?: string;
  lastModifiedDate?: Date;
  enlaceArchivo?: string;
  nombreArchivoStorage?: string;
}
